import React, { useContext, useEffect, useMemo, useRef, useState } from "react";

import styles from "./Main.module.css";

import { Button, Checkbox, Form, Input, Menu } from "antd";
import { AppContext } from "../App.context";
import axios from "axios";
import { checkEmpty } from "../service/util.service";
import { useNavigate } from "react-router-dom";
import PrivateRoute from "../menu/PrivateRoute";
import MenuTop from "../menu/MenuTop";
import MenuLett from "../menu/Menu";

function CheckLot(props) {

  return (
    <>
      <MenuLett />
      <div className={styles.boxMain}>
        <MenuTop />
        <Content/>
      </div>
    </>
  );
}
function Content(props) {
  return (
    <>
      <div>
        <h1>CheckLot</h1>
      </div>
    </>
  );
}
export default CheckLot;
